import { useGameList } from "./useGameList.ts";

export const useUpcomingGames = (
  competitionId: string | undefined,
  includeRunningGame: boolean,
) => {
  const games = useGameList(competitionId);

  if (!games.isSuccess) {
    return null;
  }

  if (includeRunningGame) {
    return games.data.games.filter((g) => !g.result);
  }

  return games.data.games.filter((g) => !g.result && !g.started);
};
